import { inject, Injectable } from '@angular/core';
import { ChangeTyped, Query, searchPath, SearchResult } from '@damofire/data-commons';
import { collectionChanges, DocumentChangeType, DocumentData, Firestore, Query as FirestoreQuery, query } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ObservableQueryService } from './services';

@Injectable()
export class FirestoreQueryService extends ObservableQueryService {
  private readonly firestore = inject(Firestore);

  observeChanges<T>(collectionRef: FirestoreQuery<T | DocumentData>, events?: DocumentChangeType[]): Observable<ChangeTyped<T[]>> {
    return collectionChanges(query(collectionRef), { events }).pipe(
      map((changes) =>
        changes.map((c): ChangeTyped<T> => {
          return { ...(c.doc.data() as T), _id: c.doc.id, changeType: c.type };
        }),
      ),
    );
  }

  async collection<T>(path: string, q: Query, searchFields?: string[]): Promise<SearchResult<T>> {
    return searchPath(this.firestore, path, q, searchFields);
  }
}
